<template>
  <div>
    <div style="font-family: DINCond; position: absolute; top: 100px">.</div>
    <div class="canvas page3D" ref="canvas" :class="bgimgnumber == 1?'black':'gray'">
      <div class="loading3d" v-if="loading">{{ loadingNum }}%</div>
    </div>
  </div>
</template>
<script>
  import * as THREE from "../common/three/three.module.js";
  import videoModel from "../components/videoModel";
  import mobileProxy from "@/common/mobileProxy";

  import {
    OrbitControls
  } from "../common/three/jsm/OrbitControls.js";
  // import {
  //   RoomEnvironment
  // } from '../common/three/jsm/RoomEnvironment.js';
  import {
    RGBELoader
  } from "../common/three/jsm/RGBELoader.js";
  import {
    GLTFLoader
  } from "../common/three/jsm/GLTFLoader.js";
  // import {
  //   EffectComposer
  // } from '../common/three/jsm/EffectComposer.js';
  // import {
  //   RenderPass
  // } from '../common/three/jsm/RenderPass.js';
  // import {
  //   UnrealBloomPass
  // } from '../common/three/jsm/UnrealBloomPass.js';
  // import utils from "../utils.js";
  // import {
  //   USDZExporter
  // } from '../common/three/jsm/USDZExporter.js';
  // import {
  //   RectAreaLightHelper
  // } from '../common/three/jsm/RectAreaLightHelper.js';
  export default {
    components: {
      videoModel,
    },
    data() {
      return {
        bgimgnumber: 1,
        config: {
          default: {
            gltfSceneScaleSet: {
              x: 1,
              y: 1,
              z: 1,
            },
            controlsTargetSet: {
              x: 0,
              y: 0,
              z: 0,
            },
            gltfScenePositionSet: {
              x: -0.035,
              y: -0.065,
              z: 0,
            },
            cameraPositionSet: {
              x: 0,
              y: 0,
              z: 0.6,
              // x: -2.5,
              // y: 0.6,
              // z: 3.0,
            },
          },
        },
        curConfig: {},
        dataObj: {
          id: "",
          opusattrid: "",
        },
        showVideoBox: false,
        loading: true,
        loadingNum: 0,
        loadingTimer: null,
        isiOS: !!navigator.userAgent.match(/(i[^;]+;( U;)? CPU.+Mac OS X)/),
        isAndroid: navigator.userAgent.indexOf("Android") > -1 ||
          navigator.userAgent.indexOf("Linux") > -1,
        camera: "",
        scene: "",
        renderer: "",
        cubeCamera: "",
        number: "", // 编号
        imgName: "", // 图片名称
        imgUrl: "", // 图片地址
        chartletImg: "", // 贴图img
        chartletImg2: "", // 贴图img
        mapImg: "", // 贴图img
        gltfUrl: "",
        codecolor: "",
        gltfUrlArray: []
      };
    },
    methods: {
      backPage() {
        this.$router.go(-1);
        if (this.isiOS) {
          mobileProxy.communication({
            name: "close",
            body: {},
          });
        } else if (this.isAndroid) {
          try {
            Mobile.finishActivity();
          } catch (e) {
            console.log("与端内交互失败,原因:接口报错");
          }
        }
      },
      //绘制文字到canvas，判断换行位置，和设置canvas高度
      canvasWrapText(options) {
        console.log(window.devicePixelRatio)
        //有时候设置的文字显示不全，需要仔细摸索行高，和绘制起始y坐标和字体大小之间的关系 更简单粗暴的就是下面canvas.height 赋值的时候多赋值点
        var settings = {
          canvas: document.createElement("canvas"), //canvas对象，必填，不填写默认创建一个canvas
          canvasWidth: 256, //canvas的宽度
          canvasMinHeight: 64, //canvas的最小高度,如果不需要可以设置为0
          drawStartX: 10, //绘制字符串起始x坐标
          drawStartY: 30, //绘制字符串起始y坐标
          lineHeight: 64, //文字的行高
          font: 60 * window.devicePixelRatio + "px DINCond", //文字样式
          text: "请修改掉默认的配置", //需要绘制的文本
          drawWidth: 256, //文字显示的宽度
          color: this.codecolor, //文字的颜色
          backgroundColor: "rgba(255, 255, 255, 0)", //背景颜色
        };
        //将传入的配置覆盖掉默认配置
        if (!!options && typeof options === "object") {
          for (var i in options) {
            settings[i] = options[i];
          }
        }

        //获取2d的上线文开始设置相关属性
        var canvas = settings.canvas;
        canvas.width = settings.canvasWidth * window.devicePixelRatio;
        canvas.height = settings.canvasMinHeight * window.devicePixelRatio;
        var ctx = canvas.getContext("2d");

        //绘制文字
        ctx.font = settings.font;
        ctx.fillStyle = settings.color;
        ctx.textAlign = "center";

        //绘制背景色
        ctx.fillStyle = settings.backgroundColor;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        //设置字体颜色
        ctx.font = settings.font;
        ctx.textBaseline = "middle";
        ctx.fillStyle = settings.color;
        ctx.fillText(
          settings.text,
          settings.canvasWidth * window.devicePixelRatio / 2,
          settings.drawStartY * window.devicePixelRatio
        );
        return canvas.toDataURL();
      },
      // 创建textureLoader
      createTextureLoader() {
        var textureLoader = new THREE.TextureLoader();
        this.chartletImg = textureLoader.load(
          "https://cdn.mintstech.cn/images/" + this.imgUrl
        );
        this.chartletImg.encoding = THREE.sRGBEncoding;
        this.chartletImg.wrapS = THREE.RepeatWrapping;
        this.chartletImg.wrapT = THREE.RepeatWrapping;
        this.chartletImg.rotation = Math.PI;
        this.chartletImg.repeat.set(-1, 1);

        this.mapImg = textureLoader.load(
          // "../../../static/gltf/261645586634_.pic.jpg"
          "../../../static/gltf/LunYi_C_AO.jpg"
        );
        this.mapImg.encoding = THREE.sRGBEncoding;
        this.mapImg.wrapS = THREE.RepeatWrapping;
        this.mapImg.wrapT = THREE.RepeatWrapping;
        this.mapImg.rotation = Math.PI;
        this.mapImg.repeat.set(-1, 1);

        //调用函数获取到img的data数据
        var data = this.canvasWrapText({
          // canvas: document.getElementById("canvas"),
          text: this.number,
        });
        this.chartletImg2 = textureLoader.load(data);
        this.chartletImg2.encoding = THREE.sRGBEncoding;
        this.chartletImg2.wrapS = THREE.RepeatWrapping;
        this.chartletImg2.wrapT = THREE.RepeatWrapping;
        this.chartletImg2.rotation = Math.PI;
        this.chartletImg2.repeat.set(-1, 1);
      },
      // 创建renderer
      createRenderer() {
        this.renderer = new THREE.WebGLRenderer({
          antialias: true,
          alpha: true,
        });
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(window.innerWidth, this.$refs.canvas.offsetHeight);
        this.renderer.toneMapping = THREE.LinearToneMapping;
        this.renderer.outputEncoding = THREE.sRGBEncoding;
        this.renderer.shadowMapEnabled = true;
        //按层级进行先后渲染
        this.renderer.sortObjects = true;
      },
      // 创建相机
      createCamera() {
        //设置透明物体的渲染层级（默认是0）
        this.camera = new THREE.PerspectiveCamera(
          45,
          window.innerWidth / this.$refs.canvas.offsetHeight,
          0.25,
          20
        );
        this.camera.position.set(this.curConfig.cameraPositionSet.x, this.curConfig.cameraPositionSet.y, this.curConfig
          .cameraPositionSet.z);
        // this.camera.position.set(-2.5, 0.6, 3.0);
        this.scene = new THREE.Scene();
        this.cubeCamera = new THREE.CubeCamera(0.1, 1000, 256);
        this.scene.add(this.cubeCamera);
      },
      // 创建灯光
      createLight() {
        var ambientLight = new THREE.AmbientLight(0xffffff, 0.8);
        this.scene.add(ambientLight);
      },
      complement(num) {
        if (num < 100 && num > 10) {
          return "0" + num;
        } else if (num < 10) {
          return "00" + num;
        } else {
          return num;
        }
      },

      init(code, maxNum) {
        this.loading = true;
        let that = this;
        var obj = {
          id: this.$route.query.id,
          opusattrid: this.$route.query.opusattrid,
        };
        var gltfLoadedNum = 0;
        Object.assign(this.dataObj, obj);
        this.number =
          "#" +
          this.complement(code) +
          "/" +
          maxNum;
        this.createTextureLoader();
        this.createRenderer();
        this.createCamera();
        this.createLight();
        new RGBELoader()
          .setPath("../../../static/gltf/")
          .load("venice_sunset_1k.hdr", (texture) => {
            this.pmremGenerator = new THREE.PMREMGenerator(this.renderer);
            this.pmremGenerator.compileEquirectangularShader();
            const envMap = this.pmremGenerator.fromEquirectangular(texture).texture;
            this.pmremGenerator.dispose();

            // texture.mapping = THREE.EquirectangularReflectionMapping;
            // texture.encoding = THREE.RGBEEncoding; //设置编码属性的值
            this.scene.background = "";
            // this.scene.environment = texture;
            this.scene.environment = envMap;

            // const loader = new GLTFLoader().setPath('../../../static/gltf/');
            const loader = new GLTFLoader().setPath("");

            if (this.gltfUrl) {
              loader.load(
                this.gltfUrl,
                async (gltf) => {
                    gltf.scene.scale.set(
                      this.curConfig.gltfSceneScaleSet.x,
                      this.curConfig.gltfSceneScaleSet.y,
                      this.curConfig.gltfSceneScaleSet.z
                    );
                    // gltf.scene.position.set(
                    //   this.curConfig.gltfScenePositionSet.x,
                    //   this.curConfig.gltfScenePositionSet.y,
                    //   this.curConfig.gltfScenePositionSet.z
                    // );
                    gltf.scene.traverse((item) => {
                      console.log(item)
                      if (item.material) {
                        if (item.name == 'zz_shuangjiegun_1') {
                          if (item.isMesh) {
                            item.material.emissive = new THREE.Color(255, 255, 255);
                            item.material.emissiveIntensity = 1;
                            item.material.emissiveMap = this.mapImg;
                          }
                        }
                        item.material.metalness *= 1;
                        // item.material.emissive = new THREE.Color(255, 255, 0);
                        // console.log(item.material.color, new THREE.Color(255, 255, 0))
                        // item.material.emissiveMap = item.material.map;
                        //   item.material.normalScale.set(2, -2);
                        //   item.material = new THREE.MeshBasicMaterial({
                        //     map: this.mapImg,
                        //     transparent: true,
                        //     side: THREE.DoubleSide
                        //   });
                        //   //   item.material.emissive = item.material.color;
                        //   //   item.material.emissiveMap = item.material.map;
                        //   //   // item.materials.shading = THREE.MeshFaceMaterial()
                      }
                      if (item.name == "Collection_P_") {
                        if (item.material && this.$route.query.creator != "王晰")
                          item.material.map = this.chartletImg;
                      }
                      if (item.name == "Collection_P_001") {
                        if (code - 0 > 0 && maxNum - 0 > 0) {
                          // item.material = new THREE.MeshBasicMaterial({
                          //   map: this.chartletImg2,
                          //   transparent: true,
                          //   side: THREE.DoubleSide
                          // });
                          if (this.$route.query.creator == "王晰") {
                            // item.position.set(-3, 0, 1);
                          }
                        } else {
                          item.position.set(0, 0, 1);
                        }
                      }
                    });
                    this.scene.add(gltf.scene);

                    // if (code - 0 <= 0 && maxNum - 0 <= 0) {
                    var group = new THREE.Group();
                    var selectedObject;
                    gltf.scene.traverse(function (obj) {
                      if (obj.name === 'BianHuang') {
                        selectedObject = obj;
                        obj.geometry.dispose();
                        obj.material.dispose();
                      }
                    })
                    group.add(selectedObject)
                    this.scene.remove(group);
                    // }

                    // function animate() {
                    // requestAnimationFrame(animate);
                    // gltf.scene.rotation.y += 0.005;
                    // const sceneBox = new THREE.Box3().setFromObject(that.scene);
                    // var center = new THREE.Vector3();
                    // sceneBox.getCenter(center);
                    // that.camera.lookAt(center);
                    // that.camera.updateProjectionMatrix();
                    // controls.target.set(center.x, center.y, center.z);
                    // render();
                    // }
                    animate()
                    this.loading = false;
                  },
                  (item, loaded, total) => {
                    var contentLength;
                    var loaded = item.loaded;
                    if (item.lengthComputable) {
                      contentLength = item.total;
                    } else {
                      contentLength = item.target.getAllResponseHeaders();
                    }
                    var percent = ((loaded / contentLength) * 100).toFixed(0);

                    this.loadingNum = percent;
                    if (percent >= 100) {
                      this.$refs.canvas.appendChild(this.renderer.domElement);
                    }
                  }
              );
            } else {

              this.renderer.toneMappingExposure = 0.2;
              for (let i = 0; i < this.gltfUrlArray.length; ++i) {
                loader.load(
                  this.gltfUrlArray[i],
                  async (gltf) => {
                      ++gltfLoadedNum
                      gltf.scene.scale.set(
                        this.curConfig.gltfSceneScaleSet.x,
                        this.curConfig.gltfSceneScaleSet.y,
                        this.curConfig.gltfSceneScaleSet.z
                      );
                      // gltf.scene.position.set(
                      //   this.curConfig.gltfScenePositionSet.x,
                      //   this.curConfig.gltfScenePositionSet.y,
                      //   this.curConfig.gltfScenePositionSet.z
                      // );

                      gltf.scene.traverse((e) => {
                        if (e.material) {
                          var mat = new THREE.MeshPhysicalMaterial({
                            emissive: 0xff0000, // emissive默认黑色，设置为白色
                            // emissiveMap: texLoader.load("./模型/emissiveMap.png"),
                          })
                          // e.material.map = mat;
                          // e.material = new THREE.MeshBasicMaterial({
                          //   emissive: mat
                          // });
                          console.log(e)
                          if (e.name == 'zz_shuangjiegun_1') {
                            if (e.isMesh) {
                              e.material.emissive = e.material.emissive;
                              e.material.emissiveIntensity = 2;
                              // e.material.emissiveMap = e.material.map;
                            }
                            e.material.metalness *= 1;
                          } else {

                            e.material.metalness *= 1;
                          }
                          // item.materials.shading = THREE.MeshFaceMaterial()
                        }
                      });

                      this.scene.add(gltf.scene);
                      if (gltfLoadedNum == this.gltfUrlArray.length) {
                        // const box = new THREE.BoxHelper( this.scene, 0xffff00 );
                        // this.scene.add( box );
                        const sceneBox = new THREE.Box3().setFromObject(this.scene);
                        var center = new THREE.Vector3();
                        sceneBox.getCenter(center);
                        this.camera.lookAt(center);
                        this.camera.updateProjectionMatrix();
                        controls.target.set(center.x, center.y, center.z);
                        this.loading = false;

                        setTimeout(() => {
                          render();
                          animate()
                        }, 10)
                      }


                      console.log(gltfLoadedNum, this.gltfUrlArray.length)
                    },
                    (item, loaded, total) => {
                      var contentLength;
                      var loaded = item.loaded;
                      if (item.lengthComputable) {
                        contentLength = item.total;
                      } else {
                        contentLength = item.target.getAllResponseHeaders();
                      }
                      var percent = ((loaded / contentLength) * 100).toFixed(0);

                      this.loadingNum = percent;
                      // if (percent >= 100) {
                      this.$refs.canvas.appendChild(this.renderer.domElement);
                      // }

                    }
                );

              }


            }

          });



        function animate() {
          requestAnimationFrame(animate);
          that.scene.rotation.y += 0.005;
          render();
        }
        const controls = new OrbitControls(this.camera, this.renderer.domElement);

        controls.maxDistance = 9
        controls.minDistance = 0.1
        controls.enableZoom = false;
        controls.rotateSpeed = 3; //旋转的速度，其默认值为1.
        controls.autoRotate = true;
        // console.log(this.curConfig.controlsTargetSet.x)
        controls.target.set(
          this.curConfig.controlsTargetSet.x,
          this.curConfig.controlsTargetSet.y,
          this.curConfig.controlsTargetSet.z
        );

        // controls.dispose('contextmenu');
        controls.mouseButtons = {
          //这一对象包含了对用于控制的鼠标按钮的引用。
          LEFT: THREE.MOUSE.ROTATE,
          MIDDLE: THREE.MOUSE.DOLLY,
          // RIGHT: THREE.MOUSE.PAN
        };
        controls.touches = {
          //This object contains references to the touch actions used by the controls.
          // ONE: THREE.TOUCH.ROTATE,
          // TWO: THREE.TOUCH.DOLLY_ROTATE,
        };
        controls.addEventListener("change", render); // use if there is no animation loop
        controls.update();
        window.addEventListener("resize", onWindowResize);

        function onWindowResize() {
          that.camera.aspect = window.innerWidth / that.$refs.canvas.offsetHeight;
          that.camera.updateProjectionMatrix();
          that.renderer.setSize(window.innerWidth, that.$refs.canvas.offsetHeight);
          render();
        }

        function render() {
          // const bloomPass = new UnrealBloomPass(new THREE.Vector2(window.innerWidth, that.$refs.canvas.offsetHeight),
          //   1.5,
          //   0.4,
          //   0.85);
          // bloomPass.threshold = 0;
          // bloomPass.strength = 0.5;
          // bloomPass.radius = 0.5;

          // const renderScene = new RenderPass(that.scene, that.camera);
          // var composer
          // composer = new EffectComposer(that.renderer);
          // composer.addPass(renderScene);
          // composer.addPass(bloomPass);

          // that.renderer.toneMappingExposure = Math.pow(1, 4.0);
          that.renderer.render(that.scene, that.camera);

          // composer.setSize(window.innerWidth, that.$refs.canvas.offsetHeight);
          // composer.render();
        }
        render();
      },
      // 查询模型
      queryGltflist() {
        this.$fetchql
          .japiFetch("post", "appapi/unitymodel/prop/info", {
            opusid: this.$route.query.id - 0,
            opusattrid: this.$route.query.opusattrid - 0,
          })
          .then((res) => {
            try {
              this.bgimgnumber = res.data.bgimgnumber;
              // "modelurl": "62460a774059db0d.gltf", //模型地址：如果type是2，这里是个数组字符串
              // "coverimgurl": "eb32fdf5c1fbfb97.jpg", //模型贴图
              // "codecolor": "#000000", //模型边框颜色
              // "type": 1 //模型类型：1，一对一；2，一对多
              this.curConfig = Object.assign(this.curConfig, this.config.default);
              if (res.data.type == 1) {

                this.gltfUrl = res.data.modelurl;
                if (!this.gltfUrl) {
                  this.showErrorAndBack();
                  return;
                }
                this.imgUrl = res.data.coverimgurl;
                this.codecolor = res.data.codecolor || '#1ce89e';
                // this.gltfUrl = 'untitled1.gltf'
                this.curConfig.cameraPositionSet = {
                  x: -2.5,
                  y: 0.6,
                  z: 1,
                };
              } else {
                var models = JSON.parse(res.data.modelurl);
                if (models.length == 0) {
                  this.showErrorAndBack();
                  return;
                }
                for (var i = 0; i < models.length; ++i) {
                  this.gltfUrlArray[i] = models[i];
                }

                this.curConfig.cameraPositionSet = {
                  x: 0,
                  y: 0,
                  // z: 0.6,
                  z: 3,
                };
              }
              this.init(res.data.code, res.data.qty);
            } catch (err) {
              this.showErrorAndBack();
            }
          });
      },
      showErrorAndBack() {
        // this.$toast({
        //   message: "网络异常，请稍后再试！",
        //   duration: 1500,
        // });
        setTimeout(() => {
          this.$router.go(-1);
        }, 2000);
      },
    },

    mounted() {
      this.queryGltflist();
      console.log(this.$refs.canvas.offsetHeight)
      console.log(new Blob())
    },
  };

</script>
<style lang="less" scoped>
  @font-face {
    font-family: "DINCond";
    src: url("../../static/fonts/DINCond-Medium.otf");
  }



  .canvas {
    position: relative;
    width: 100%;
    height: 418px;

    &.black {
      // background: url("/static/gltf/bg/1bg.png") center center;
      background: #000000;
      // background-size: 100% 418px;
    }

    &.gray {
      background: url("/static/gltf/bg/2bg.png")center center;
      background-size: 100% 418px;
    }

    // background: radial-gradient(ellipse, #FFFFFF 0%, #E7E7E7 35%, #868686 100%);
    background-size: 100% 418px;

    .loading3d {
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -42px;
      margin-top: -15px;
      width: 84px;
      height: 30px;
      border-radius: 15px;
      background: url("../../static/gltf/bg/loading.png") no-repeat 10px center rgba(255, 255, 255, 0.5);
      background-size: 23px 23px;
      line-height: 30px;
      box-sizing: border-box;
      font-weight: 500;
      color: #000000;
      font-size: 13px;
      text-indent: 40px;
      pointer-events: none;
    }
  }

</style>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/components/detail3D.vue